<!--
    Summary:
        我的
    ChangeLog:
        Labbor on 2020/2/21 added
-->
<template>
  <div class="v-box">
    <div class="v-box-main">
      <div class="img-wrapper">
        <slot></slot>
      </div>
      <div class="bottom">
        <h3 class="h3" v-if="hasTitle">
          <slot name="sub-title"></slot>
        </h3>
        <hr v-if="hasLine">
        <p class="p" v-if="hasDetail">
          <slot name="sub-detail"></slot>
        </p>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    name:"box",
    props: {
      hasTitle: {
        type: Boolean,
        default: false
      },
      hasLine: {
        type: Boolean,
        default: false
      },
      hasDetail: {
        type: Boolean,
        default: false
      },
    },
    data() {
      return {}
    },
    methods: {},
  }
</script>

<style scoped lang="scss">
  .v-box {
    padding: 0 15px;
    box-sizing: border-box;

    &:first-child {
      margin-left: -15px;
    }

    .v-box-main {
      .img-wrapper {
        padding: 0 12px 20px;
        box-sizing: border-box;
        width: 100%;
      }

      img {
        width: 100%;
      }

      .h3 {
        text-align: center;
        color: #cb3439;
      }

      .p {
        text-align: center;
      }

      hr {
        border-color: #999;
        margin: 10px 0;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/view/genedetection/box.vue